module.exports = __webpack_public_path__ + "media/v2/icon_mail-cf2203c0.svg";